import { historyReplace } from "@studiometa/js-toolkit/utils";
import { AbstractStorageProvider } from "./AbstractStorageProvider.js";
class URLStorageProvider extends AbstractStorageProvider {
  static MODES = {
    SEARCH: "search",
    HASH: "hash"
  };
  mode;
  constructor(store, mode = "search") {
    super(store);
    this.mode = mode;
  }
  async get(key) {
    return this.store.get(key);
  }
  async set(key, value) {
    this.store.set(key, value);
    historyReplace({
      [this.mode]: this.mode === this.constructor.MODES.SEARCH ? this.store : this.store.toString()
    });
  }
  async has(key) {
    return this.store.has(key);
  }
  async delete(key) {
    this.store.delete(key);
  }
}
export {
  URLStorageProvider
};
//# sourceMappingURL=URLStorageProvider.js.map
